/** Text after the caret that is an in-progress @mention, or null when the caret left one. */
export function mentionFragment(text: string, cursor: number): string | null {
  if (cursor < 0) return null;
  const safe = Math.min(cursor, text.length);
  const match = text.slice(0, safe).match(/@([A-Za-z0-9_.-]*)$/);
  return match ? match[1] : null;
}

/** Caret position just after the inserted or deleted span between two strings. */
export function editCaret(prev: string, next: string): number {
  let start = 0;
  const max = Math.min(prev.length, next.length);
  while (start < max && prev[start] === next[start]) start += 1;
  let endPrev = prev.length;
  let endNext = next.length;
  while (endPrev > start && endNext > start && prev[endPrev - 1] === next[endNext - 1]) {
    endPrev -= 1;
    endNext -= 1;
  }
  return endNext;
}

/**
 * Some browsers report selectionStart as 0 while the typed character was
 * inserted after "@". Prefer a caret that still sits on that mention.
 */
export function caretAfterEdit(prev: string, next: string, reported: number | null): number {
  if (prev === next) {
    if (reported == null) return next.length;
    return Math.max(0, Math.min(reported, next.length));
  }
  const diff = editCaret(prev, next);
  const reportedCaret =
    reported == null ? diff : Math.max(0, Math.min(reported, next.length));
  if (mentionFragment(next, reportedCaret) !== null) return reportedCaret;
  if (mentionFragment(next, diff) !== null) return diff;
  return reportedCaret;
}

export function matchesMention(
  user: { username: string; displayName: string },
  query: string,
): boolean {
  const needle = query.toLowerCase();
  if (!needle) return true;
  return (
    user.username.toLowerCase().includes(needle) ||
    user.displayName.toLowerCase().includes(needle)
  );
}
